<template>
  <div class="vertical-collapse" :class="placeClass">
    <div class="vertical-collapse__title">
      <!-- SLOT -->
      <slot name="title" :open="onOpen" :close="onClose" :toggle="onToggle"/>
    </div>
    <transition name="vertical-collapse">
      <div
        v-show="isOpen"
        class="vertical-collapse__content-wrap"
        tabindex="1000"
      >
        <div
          class="vertical-collapse__content"
          ref="content"
        >
          <!-- SLOT -->
          <slot isOpen=""/>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'VerticalCollapse',
  props: {
    value: { type: Boolean },
    place: { type: String, default: 'left' }
  },
  data () {
    return {
      model: false
    }
  },
  computed: {
    isOpen () {
      return this.model
    },
    placeClass () {
      const isRight = this.place !== 'left'
      return {
        'is-left': !isRight,
        'is-right': isRight
      }
    }
  },
  methods: {
    onToggle () {
      this.model ? this.onClose() : this.onOpen()
    },
    onOpen () {
      this.model = true
    },
    onClose () {
      this.model = false
    }
  }
}
</script>

<style lang="stylus">
  $border-radius = 1rem
.vertical-collapse{
  display flex
  height 100%
  position relative
  &__content-wrap{
    position absolute
    top 0
    background-color white
    z-index 1
    padding 2rem
    display flex
    min-height 100%
    max-width 100vw
  }
  &__title{
    position relative
    z-index 2
  }
  &__content{
    flex 1
  }
  &.is-left{
    .vertical-collapse{
      &__content-wrap{
        right 100%
        box-shadow -1rem .7rem 2.5rem 0 rgba(0,0,0,0.2)
        border-bottom-left-radius $border-radius
        border-top-left-radius $border-radius
      }
      &__title{
        order 2
      }
      &__content{
        order 1
      }
    }
  }
  &.is-right{
    .vertical-collapse{
      &__content-wrap{
        left 100%
        border-bottom-right-radius $border-radius
        border-top-right-radius $border-radius
      }
      &__title{
        order 1
      }
      &__content{
        order 2
      }
    }
  }
}
.vertical-collapse-enter-active, .vertical-collapse-leave-active {
  transition: all .5s;
}
.vertical-collapse-enter, .vertical-collapse-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
